// extracted by mini-css-extract-plugin
export default {"checkboxIos":"switchCheckbox_checkboxIos__nSNgi","checkboxIosSwitch":"switchCheckbox_checkboxIosSwitch__rlH6B"};